import { getPortalApiBase } from '../utils/portalPath';

export function buildPortalApiPath(path: `/${string}`): string {
  return `${getPortalApiBase()}${path}`;
}

export function buildSiteApiPath(siteType: string, resource: `/${string}`): string {
  return buildPortalApiPath(`/${siteType}${resource}`);
}

export function buildEnrollmentProductApiPath(product: string, resource: `/${string}`): string {
  return buildPortalApiPath(`/enrollments/products/${encodeURIComponent(product)}${resource}`);
}
